<template>
  <fragment>
    <td>{{row.sum_total_employed_ft}}</td>
    <td>{{row.sum_total_employed_pt}}</td>
    <td>{{row.sum_total_employed_ca}}</td>
    <td>{{row.sum_rqrd_french_ft}}</td>
    <td>{{row.sum_rqrd_french_pt}}</td>
    <td>{{row.sum_rqrd_french_ca}}</td>
    <td>{{row.sum_actual_french_ft}}</td>
    <td>{{row.sum_actual_french_pt}}</td>
    <td>{{row.sum_actual_french_ca}}</td>
    <td>{{row.sum_total_emp}}</td>
    <td>{{row.sum_rqrd_fr}}</td>
    <td>{{row.sum_actual_fr}}</td>
    <td>{{numberWithSign(row.etp_diff)}}</td>
    <td>{{decimalToPercent(row.etp_rqrd_ratio)}} %</td>
    <td>{{decimalToPercent(row.etp_actual_ratio)}} %</td>
    <td>{{row.etp_diff_pc}} %</td>
  </fragment>
</template>

<script>
import { Fragment } from 'vue-fragment';

export default {
  name: 'OnRatiosTableCells',
  components: {
    Fragment
  },
  props: {
    row: Object
  },
  methods: {
    numberWithSign(n) {
      if (!n || n === '0' || n < 0) {
        return n;
      }

      return '+' + n.toLocaleString();
    },
    decimalToPercent(d) {
      return Math.round( ( (d*100) + Number.EPSILON ) * 100 ) / 100
    }
  }
}

</script>